import styled from '@emotion/styled'
import { Color as YaComColor } from '@yanolja-org/ya-com-core'
import { Typography } from '@yanolja-org/ya-com-core'

export interface ThemeType {
  name: string
  color: Record<string, string>
  unit: {
    PC_WIDTH: number
  }
}

export const theme: ThemeType = {
  name: 'nol-universe',
  color: YaComColor,
  unit: {
    PC_WIDTH: 768,
  },
}

export default styled

export type Color = keyof typeof YaComColor
export type TypographyKeys = Parameters<typeof Typography>[0]
